<template>
	<span />
</template>

<script lang="ts" setup>
import type { InjuryEnum } from '#fysio/core/enums/InjuryEnum';
import { Injury } from '#fysio/core/enums/InjuryEnum';

const props = withDefaults(defineProps<{
	injury: InjuryEnum;
	withPossibleTreatments?: boolean;
}>(), {
	withPossibleTreatments: false,
});

const injury = Injury.init(props.injury);

useHead({
	script: [
		{
			type: 'application/ld+json',
			innerHTML: injury?.schema({
				possibleTreatment: props.withPossibleTreatments
					? injury?.treatments
					: undefined,
			}),
		},
	],
});
</script>
